import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface UserTokenState {
  token: string | null;
}

type SetUserToken = (token: string) => void;

const initialUserTokenState: UserTokenState = {
  token: null,
};

export const useUserTokenStore = create<
  UserTokenState & { setUserToken: SetUserToken }
>()(
  devtools(
    persist(
      (set) => ({
        ...initialUserTokenState,
        setUserToken: (token: string) => {
          set((state) => ({
            ...state,
            token,
          }));
        },
      }),
      {
        name: 'user-token-storage',
        storage: createJSONStorage(() => localStorage),
      },
    ),
  ),
);

// Hook to access setUserToken
export const useSetUserToken = () =>
  useUserTokenStore((state) => state.setUserToken);

// Function to set token directly
export const setUserToken = (token: string) => {
  useUserTokenStore.setState({ token });
};

// Function to get token directly
export const getUserToken = () => {
  return useUserTokenStore.getState().token;
};

// Hook to access token
export const useUserToken = () => useUserTokenStore((state) => state.token);

